const DashboardOrdinal = 0;
const TimeTrackingOrdinal = 100;
const ProjectOrdinal = 200;
const ClientOrdinal = 300;
const TeamOrdinal = 400;
const UserProfileOrdinal = 500;
const SettingsOrdinal = 600;
const ReportsOrdinal = 700;
const FinancesOrdinal = 800;
const TodoPlannerOrdinal = 900;

enum DashboardPageKeys {
  Dashboard = DashboardOrdinal,
}

enum TimeTrackingPageKeys {
  TimeTracking = TimeTrackingOrdinal,
  CalendarView,
  ListView,
}

enum ProjectPageKeys {
  Projects = ProjectOrdinal,
  ProjectOverview,
  ProjectAdd,
  ProjectEdit,
  ProjectProgress,
  ProjectAttachments,
  ProjectExpenses,
}

enum ClientPageKeys {
  Clients = ClientOrdinal,
  ClientList,
  ClientAdd,
  ClientEdit,
}

enum TeamPageKeys {
  Team = TeamOrdinal,
  TeamOverview,
  TeamMemberAdd,
  TeamAbsences,
  TeamAbsencePlanner,
  TeamVacationQuota,
  TeamLeaveRequests,
}

enum UserProfilePageKeys {
  UserProfile = UserProfileOrdinal,
  UserProfileEdit,
  UserProfileAttachments,
}

enum SettingsPageKeys {
  Settings = SettingsOrdinal,
  SettingsNonworkingTime,
}

enum ReportsPageKeys {
  Reports = ReportsOrdinal,
  ReportsTimetableAggregated,
  ReportsTimetableMonthly,
  ReportsTimetableTimeEntries,
}

enum FinancePageKeys {
  Finances = FinancesOrdinal,
  FinancesInvoicesOverview,
  FinancesInvoicesAdd,
  FinancesExpenses,
}

enum TodoPlannerPageKeys {
  TodoPlanner = TodoPlannerOrdinal,
}

export const PageKey = {
  DashboardPageKeys,
  TimeTrackingPageKeys,
  ProjectPageKeys,
  ClientPageKeys,
  TeamPageKeys,
  FinancePageKeys,
  UserProfilePageKeys,
  SettingsPageKeys,
  ReportsPageKeys,
  TodoPlannerPageKeys,
};
